import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "googleSheets",
  "name": "Google Sheets",
  "category": "integrations",
  "description": "Read, update, and delete data from Google Sheets",
  "icon": "siGooglesheets",
  "iconType": "simple-icon",
  "color": "green",
  "version": "4.5.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Google Sheets",
    "color": "#0f9d58"
  },
  "credentials": [
    {
      "name": "googleSheetsOAuth2",
      "required": true,
      "displayName": "Google Sheets OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "google",
    "sheets",
    "spreadsheet",
    "data",
    "excel"
  ],
  "comingSoon": true
};

export default definition;
